import { create } from 'zustand'

const NAV_PINNED_STORAGE_KEY = 'rpa_nav_pinned_v1'

const getInitialPinnedState = (): boolean => {
  if (typeof window === 'undefined') {
    return true
  }

  try {
    const raw = window.localStorage.getItem(NAV_PINNED_STORAGE_KEY)
    if (raw !== null) {
      return raw === 'true'
    }
  } catch (error) {
    console.warn('Unable to load navigation pinned state', error)
  }

  return true
}

const persistPinnedState = (pinned: boolean) => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.localStorage.setItem(NAV_PINNED_STORAGE_KEY, pinned ? 'true' : 'false')
  } catch (error) {
    console.warn('Unable to persist navigation pinned state', error)
  }
}

export type UiNavState = {
  pinned: boolean
  open: boolean
  animating: boolean
  togglePinned: () => void
  openNav: () => void
  closeNav: () => void
  toggleNav: () => void
  setAnimating: (animating: boolean) => void
}

const useUiNavStore = create<UiNavState>((set) => ({
  pinned: getInitialPinnedState(),
  open: false,
  animating: false,
  togglePinned: () =>
    set((state) => {
      const nextPinned = !state.pinned
      persistPinnedState(nextPinned)
      return {
        pinned: nextPinned,
        open: nextPinned ? false : state.open,
        animating: false,
      }
    }),
  openNav: () =>
    set((state) => {
      if (state.open) {
        return {}
      }
      return { open: true, animating: true }
    }),
  closeNav: () =>
    set((state) => {
      if (!state.open) {
        return {}
      }
      return { open: false, animating: true }
    }),
  toggleNav: () =>
    set((state) => ({ open: !state.open, animating: true })),
  setAnimating: (animating) => set({ animating }),
}))

export default useUiNavStore
